import { defineComponent } from "vue";
import common from "../core/core";

export default defineComponent({
  data() {
    return {
      addressService: this.$store.direct.getters.addressService,
    };
  },
  mixins: [common],
});
